module.exports = __webpack_public_path__ + "assets/img/gludio.66ba37b2.jpg";